<app-print-layout [printId]="printId()"
  [summaryItems]="summaryItems()"
  [visible]="visible()">
  <app-print-layout-section>
    @if (vm().room) {
      <div class="a4-pdf__stack">
        <span class="a4-pdf__eyebrow">{{ vm().roomLabel }}</span>
        <span class="a4-pdf__line">{{ vm().room }}</span>
      </div>
    }
    <div class="site-note-pdf__content"
      [innerHTML]="vm().text ?? ''"></div>
  </app-print-layout-section>
</app-print-layout>
